import { render } from "./AppointmentImportModal.vue?vue&type=template&id=0a4ae496&ts=true"
import script from "./AppointmentImportModal.vue?vue&type=script&lang=ts"
export * from "./AppointmentImportModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__